import { ROUTE_PATHS } from '@/constants';
import { pathJoin } from '@/utils';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const stepProgress = Math.ceil(100 / 5);

export const useWizardProgressBar = (): number => {
  const location = useLocation();

  const step = location.pathname;
  return useMemo(() => {
    switch (step) {
      case pathJoin([`/${ROUTE_PATHS.quote}`, ROUTE_PATHS.quoteAuctionHouseInfo]):
        return stepProgress * 2;
      case pathJoin([`/${ROUTE_PATHS.quote}`, ROUTE_PATHS.quoteShippingInfo]):
        return stepProgress * 3;
      case pathJoin([`/${ROUTE_PATHS.quote}`, ROUTE_PATHS.quoteSummary]):
        return stepProgress * 4;
      case pathJoin([`/${ROUTE_PATHS.quote}`, ROUTE_PATHS.quoteRequestedConfirmation]):
        return stepProgress * 5;
      default:
        return stepProgress;
    }
  }, [step]);
};
